module.exports = __webpack_public_path__ + "img/walking-person-filled.691214bc.gif";